<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-header-2 d-flex flex-column flex-md-row justify-space-between align-start gap-3 mb-3">
                                <div>
                                    <h4 class="mb-1">Link APIs CJ Dropshipping</h4>
                                    <p class="text-muted mb-0">Manage CJ product queries, imports, orders, logistics and tracking from one place.</p>
                                </div>
                                <div class="d-flex flex-wrap gap-2">
                                    <v-btn color="primary" variant="flat" class="text-none" :loading="loadingAction === 'syncOrders'" :disabled="loadingAction !== null" @click="getSyncAllCjOrders">Sync All CJ Orders</v-btn>
                                    <v-btn color="secondary" variant="flat" class="text-none" :loading="loadingAction === 'syncInventory'" :disabled="loadingAction !== null" @click="getSyncAllCjInventory">Sync All CJ Inventory</v-btn>
                                </div>
                            </div>
                            <div class="">
                                <v-alert
                                    v-if="message"
                                    :type="messageType"
                                    closable
                                    class="mb-4"
                                    @click:close="message = ''"
                                >
                                    {{ message }}
                                </v-alert>

                                <div class="tabs-wrapper">
                                    <v-tabs v-model="tab" class="cj-tabs">
                                    <v-tab value="products">Products</v-tab>
                                    <v-tab value="orders">Orders</v-tab>
                                    <v-tab value="logistics">Logistics</v-tab>
                                    <v-tab value="tracking">Tracking</v-tab>
                                    </v-tabs>
                                </div>

                                <v-window v-model="tab" class="cj-window">
                                <!-- Products Tab -->
                                <v-window-item value="products" style="margin-top: 0; padding-top: 0;">
                                    <v-card class="" elevation="1" style="margin-top: 0; padding-top: 16px;">
                                        <div class="page-section-title">Product actions</div>
                                        <p class="page-section-subtitle">Query CJ products, inspect details, or import them into the catalog with the desired behavior.</p>

                                        <v-row dense>
                                            <v-col cols="12" md="5">
                                                <v-text-field v-model="productForm.id" label="Product ID / SKU" placeholder="Enter ID or SKU" hide-details="auto"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="2">
                                                <v-select
                                                    v-model="productForm.type"
                                                    :items="['pid', 'productSku', 'variantSku']"
                                                    label="Type"
                                                    hide-details="auto"
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="12" md="2">
                                                <v-select
                                                    v-model="productForm.insert"
                                                    :items="['true', 'false']"
                                                    label="Insert article"
                                                    hide-details="auto"
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-select
                                                    v-model="productForm.importMode"
                                                    :items="[{ title: 'Single variant', value: 'single' }, { title: 'All variants', value: 'all' }]"
                                                    item-title="title"
                                                    item-value="value"
                                                    label="Import mode"
                                                    hide-details="auto"
                                                ></v-select>
                                            </v-col>
                                        </v-row>

                                        <div class="cj-actions mt-2">
                                            <v-btn color="primary" class="text-none" :loading="loadingAction === 'getProducts'" :disabled="loadingAction !== null" @click="getProducts">Get All Products</v-btn>
                                            <v-btn color="info" class="text-none" :loading="loadingAction === 'getProductDetails'" :disabled="loadingAction !== null" @click="getProductDetails">Get Product Details</v-btn>
                                            <v-btn color="success" class="text-none" :loading="loadingAction === 'getProductWithInventory'" :disabled="loadingAction !== null" @click="getProductWithInventory">Get Product Inventory</v-btn>
                                            <v-btn color="warning" class="text-none" :loading="loadingAction === 'getCompleteProductInfo'" :disabled="loadingAction !== null" @click="getCompleteProductInfo">Get Complete Info</v-btn>
                                        </div>
                                    </v-card>
                                </v-window-item>

                                <!-- Orders Tab -->
                                <v-window-item value="orders" style="margin-top: 0; padding-top: 0;">
                                    <v-card class="pa-4" elevation="1" style="margin-top: 0; padding-top: 16px;">
                                    <div class="row">
                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Order Number</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.orderNumber" placeholder="Order Number"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Customer Name</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.shippingCustomerName" placeholder="Customer Name"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Address</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.shippingAddress" placeholder="Address"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">City</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.shippingCity" placeholder="City"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Province/State</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.shippingProvince" placeholder="Province/State"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Country</label>
                                        <div class="col-sm-5">
                                            <v-text-field v-model="orderForm.shippingCountry" placeholder="Country"></v-text-field>
                                        </div>
                                        <div class="col-sm-5">
                                            <v-text-field v-model="orderForm.shippingCountryCode" placeholder="Country Code"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">ZIP Code</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.shippingZip" placeholder="ZIP Code"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Phone</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.shippingPhone" placeholder="Phone"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Products</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="orderForm.products[0].vid" placeholder="Product VID"></v-text-field>
                                            <v-text-field 
                                            v-model.number="orderForm.products[0].quantity" 
                                            type="number" 
                                            placeholder="Quantity"
                                            ></v-text-field>
                                        </div>
                                        </div>
                                    </div>

                                    <div class="d-flex gap-2">
                                        <v-btn color="primary" :loading="loadingAction === 'createOrder'" :disabled="loadingAction !== null" @click="createOrder">Create Order</v-btn>
                                        <v-btn color="info" :loading="loadingAction === 'getListOrders'" :disabled="loadingAction !== null" @click="getListOrders">List Orders</v-btn>
                                        <v-btn color="warning" :loading="loadingAction === 'getOrderDetail'" :disabled="loadingAction !== null" @click="getOrderDetail">Get Order Details</v-btn>
                                        <v-btn color="error" :loading="loadingAction === 'deleteOrder'" :disabled="loadingAction !== null" @click="deleteOrder">Delete Order</v-btn>
                                    </div>
                                    </v-card>
                                </v-window-item>

                                <!-- Logistics Tab -->
                                <v-window-item value="logistics" style="margin-top: 0; padding-top: 0;">
                                    <v-card class="pa-4" elevation="1" style="margin-top: 0; padding-top: 16px;">
                                    <div class="row">
                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Start Country</label>
                                        <div class="col-sm-4">
                                            <v-text-field v-model="freightForm.startCountryCode" placeholder="Start Country Code"></v-text-field>
                                        </div>
                                        <label class="form-label-title col-sm-2 mb-0">End Country</label>
                                        <div class="col-sm-4">
                                            <v-text-field v-model="freightForm.endCountryCode" placeholder="End Country Code"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">ZIP Code</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="freightForm.zipCode" placeholder="ZIP Code"></v-text-field>
                                        </div>
                                        </div>

                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Products</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="freightForm.products[0].vid" placeholder="Product VID"></v-text-field>
                                            <v-text-field 
                                            v-model.number="freightForm.products[0].quantity" 
                                            type="number" 
                                            placeholder="Quantity"
                                            ></v-text-field>
                                        </div>
                                        </div>
                                    </div>

                                    <div class="d-flex gap-2">
                                        <v-btn color="primary" :loading="loadingAction === 'calculateFreight'" :disabled="loadingAction !== null" @click="calculateFreight">Calculate Freight</v-btn>
                                    </div>
                                    </v-card>
                                </v-window-item>

                                <!-- Tracking Tab -->
                                <v-window-item value="tracking" style="margin-top: 0; padding-top: 0;">
                                    <v-card class="pa-4" elevation="1" style="margin-top: 0; padding-top: 16px;">
                                    <div class="row">
                                        <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Tracking Number</label>
                                        <div class="col-sm-10">
                                            <v-text-field v-model="trackingNumber" placeholder="Enter tracking number"></v-text-field>
                                        </div>
                                        </div>
                                    </div>

                                    <div class="d-flex gap-2">
                                        <v-btn color="primary" :loading="loadingAction === 'getTrackingInfo'" :disabled="loadingAction !== null" @click="getTrackingInfo">Get Tracking Info</v-btn>
                                    </div>
                                    </v-card>
                                </v-window-item>
                                </v-window>

                                <!-- Response Display -->
                                <v-card v-if="loadingAction" class="pa-4 text-center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </v-card>
                                <v-card v-else-if="apiResponse" class="pa-4">
                                <pre>{{ JSON.stringify(apiResponse, null, 2) }}</pre>
                                </v-card>
                            </div>
                            <br>
                            <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError" closable @click:close="messageError = ''"></v-alert>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'

export default {
    name: 'app',
    title: 'Link APIs',
    watch: {
        country() {
            if(this.cargado){
                this.province=null
            }
            if(this.country && this.country.id){
                this.getListProvince(this.country.id)
            } 
            
        },
    },
    data() {
        return {
            cargado:false,
            id: null,
            cif: '',
            name: '',
            address: '',
            addressnumber: '',
            dataCountryCombo: [],
            country: '',
            dataProvinceCombo: [],
            province: '',
            city: '',
            postalcode: '',
            email: '',
            phone: '',
            IBAN: '',
            messageError: '',
            typeOfMessage: '',








            tab: 'products',
            message: '',
            messageType: 'info',
            apiResponse: null,
            loadingAction: null,
            baseUrl: process.env.VUE_APP_URL_API_BASE + '/admin/linkapis',

            productForm: {
                id: '',
                type: 'pid',
                insert: false,
                importMode: 'single'
            },

            orderForm: {
                orderNumber: '',
                shippingZip: '',
                shippingCountry: '',
                shippingCountryCode: '',
                shippingProvince: '',
                shippingCity: '',
                shippingPhone: '',
                shippingCustomerName: '',
                shippingAddress: '',
                logisticName: '',
                fromCountryCode: 'CN',
                houseNumber: '',
                taxId: '',
                remark: '',
                iossType: '1',
                products: [{
                    vid: '',
                    quantity: 1
                }]
            },

            freightForm: {
                startCountryCode: '',
                endCountryCode: '',
                zipCode: '',
                products: [{
                    vid: '',
                    quantity: 1
                }]
            },

            trackingNumber: ''
        }
    },
    methods: {
        async validate() {
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                this.create()
            } else {
                alert('Faltan parametros')
            }
        },
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        async linkAPI(){
            let newObject = {
                usuario: 'capdevila581@gmail.com'
            }

            
            await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/linkapis/login', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            })
            .then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message + ' ' + response.data
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message + ' ' + response.data
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
                
            })
            .catch((error) => {
                this.messageError = 'Error!' + error
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error(error)
            }) 


        },
        async getSyncAllCjOrders() {
            this.messageError = ''
            this.loadingAction = 'syncOrders'
            await axios.get(process.env.VUE_APP_URL_API_BASE + '/sync-all-cj-orders')
                .then((response) => {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                })
                .catch((error) => {
                    this.messageError = 'Error!' + error
                    this.typeOfMessage = 'error'
                })
                .finally(() => {
                    this.loadingAction = null
                })
        },
        async getSyncAllCjInventory() {
            this.messageError = ''
            this.loadingAction = 'syncInventory'
            await axios.get(process.env.VUE_APP_URL_API_BASE + '/sync-all-cj-inventory')
                .then((response) => {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                })
                .catch((error) => {
                    this.messageError = 'Error!' + error
                    this.typeOfMessage = 'error'
                })
                .finally(() => {
                    this.loadingAction = null
                })
        },
        getListCountry() {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/country/list'   

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        self.dataCountryCombo = []
                        self.dataCountryCombo = response.data


                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        getListProvince(id) {
            let self = this

            let apiURL = process.env.VUE_APP_URL_API_BASE + '/country/' + id + '/provinces/list'

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        self.dataProvinceCombo = []
                        self.dataProvinceCombo = response.data

                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        create() {
            let newObject = {
                cif: this.cif,
                name: this.name,
                address: this.address,
                addressnumber: this.addressnumber,
                city: this.city,
                postalcode: this.postalcode,
                email: this.email,
                phone: this.phone,
                IBAN: this.IBAN,
            }
            if(this.country && this.country.id){
                newObject.country_id = this.country.id
            }
            if(this.province && this.province.id){
                newObject.province_id = this.province.id
            }

             axios.post('http://localhost:8001/admin/vendor/create', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }
                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha creado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
            })
        },




        async makeRequest(endpoint, method = 'GET', data = null, actionName = null) {
            this.apiResponse = null
            this.message = ''
            this.loadingAction = actionName

            try {
                const config = {
                method,
                url: `${this.baseUrl}${endpoint}`,
                responseType: 'json'
                }

                if (data) {
                config.data = data
                }

                const response = await axios(config)
                this.apiResponse = response.data
                this.message = response.data.message
                this.messageType = response.data.error ? 'error' : 'success'
            } catch (error) {
                this.message = `Error: ${error.message}`
                this.messageType = 'error'
                this.apiResponse = error.response?.data
            } finally {
                this.loadingAction = null
            }
            // El mensaje se queda visible (no se autoborra) hasta la siguiente petición o hasta que
            // el usuario lo descarte: si la petición tarda y cambia de pestaña, al volver debe seguir viendo el resultado.
        },

        // Products
        async getProducts() {
            await this.makeRequest('/products', 'GET', null, 'getProducts')
        },

        async getProductDetails() {
            await this.makeRequest(`/product/${this.productForm.id}/${this.productForm.type}/${this.productForm.insert}`, 'GET', null, 'getProductDetails')
        },

        async getProductWithInventory() {
            await this.makeRequest(`/product-inventory/${this.productForm.id}/${this.productForm.type}`, 'GET', null, 'getProductWithInventory')
        },

        async getCompleteProductInfo() {
            const importMode = this.productForm.importMode || 'single'
            await this.makeRequest(`/product-complete/${this.productForm.id}/${this.productForm.type}/${this.productForm.insert}/${encodeURIComponent(importMode)}`, 'GET', null, 'getCompleteProductInfo')
        },

        // Orders
        async createOrder() {
            await this.makeRequest('/orders', 'POST', this.orderForm, 'createOrder')
        },

        async getListOrders() {
            await this.makeRequest('/orders', 'GET', null, 'getListOrders')
        },

        async getOrderDetail() {
            await this.makeRequest(`/orders/${this.orderForm.orderNumber}`, 'GET', null, 'getOrderDetail')
        },

        async deleteOrder() {
            await this.makeRequest(`/orders/${this.orderForm.orderNumber}`, 'DELETE', null, 'deleteOrder')
        },

        // Logistics
        async calculateFreight() {
            await this.makeRequest('/freight', 'POST', this.freightForm, 'calculateFreight')
        },

        // Tracking
        async getTrackingInfo() {
            await this.makeRequest(`/tracking/${this.trackingNumber}`, 'GET', null, 'getTrackingInfo')
        }
    },
    async created() {
        //await this.getListCountry()
        this.cargado=true
    }
}
</script>

<style>
.tabs-wrapper {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.cj-tabs {
    margin-bottom: 0 !important;
}

.cj-window {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.cj-window .v-window-item {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.cj-window .v-window-item > .v-card {
    margin-top: 0 !important;
}

.page-section-title {
    font-size: 1.05rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
}

.page-section-subtitle {
    color: rgba(0, 0, 0, 0.64);
    margin-bottom: 1rem;
}

.cj-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}
</style>
